import React from 'react';
import MeetingConfirmButton from './MeetingConfirmButton';
import MeetingRejectButton from './MeetingRejectButton';
import MeetingRescheduleButton from './MeetingRescheduleButton';
import styles from './MeetingStateController.module.scss';

function MeetingStateController(props) {
    const { className = '', event, meeting, confirmClassName, rescheduleClassName, rejectClassName } = props;

    return (
        <div className={[className, styles.MeetingStateController].join(' ')}>
            <div className={styles.options}>
                <MeetingConfirmButton className={confirmClassName} meeting={meeting} />
                <MeetingRescheduleButton className={rescheduleClassName} eventId={event.id} meeting={meeting} />
                <MeetingRejectButton className={rejectClassName} meeting={meeting} />
            </div>
        </div>
    );
}

export default MeetingStateController;
